let mouseMoveListenerAdded = false;
let keyDownListenerAdded = false;
export function addMouseMoveAndKeyDownListener(debouncedMouseMove, debouncedKeyDown) {
  if (!mouseMoveListenerAdded) {
    window.addEventListener("mousemove", debouncedMouseMove);
    mouseMoveListenerAdded = true;
  }

  if (!keyDownListenerAdded) {
    window.addEventListener("keydown", debouncedKeyDown);
    keyDownListenerAdded = true;
  }
}
